module.exports = __webpack_public_path__ + "img/nublado.f9efe57c.png";